$ = require 'jquery'
Auth = require 'db/auth'
MultiBoardGuestBannerComponent = require 'views/organization/multi-board-guest-banner-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
OrgFeatures = require 'data/org-features'
View = require 'view'
recup = require 'recup'
moment = require 'moment'
trackUe = require 'debug/trackUe'

MULTI_BOARD_GUEST = 'MultiBoardGuest'

module.exports = class MultiBoardGuestBannerView extends View
  initialize: ->
    @listenTo Auth.me(),
      'change:oneTimeMessagesDismissed', @frameDebounce @render
    @listenTo @model,
      'change:paidAccount': @frameDebounce @renderReactSection
      'change:memberships': @frameDebounce @renderReactSection
      'change:billableCollaboratorCount': @frameDebounce @renderReactSection

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getMultiBoardGuestBanner()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  render: ->
    @$reactRoot ?= $('<div></div>')
    if @model.owned()
      @$el.append(@$reactRoot)
      @renderReactSection()
    else
      @$el.empty()

    @

  upgradeableProductCodes: ->
    products = @model.get('products')
    if @model.get('paidAccount')?.pendingProduct?
      products.push(@model.get('paidAccount').pendingProduct)

    return products.filter(
      (product) => OrgFeatures.isFeatureEnabled('toBeUpgradedToMBGPlan', [product]) &&
      !@model.get('paidAccount')?.expirationDates?[product]
    )

  getNextProduct: ->
    paidAccount = @model.get('paidAccount')
    if !paidAccount?.billingDates?
      return null
    productInfo = @upgradeableProductCodes().reduce((productInfo, product) =>
      if !paidAccount.billingDates?[product]?
        return productInfo
      if !productInfo? || productInfo.nextBillingDate > paidAccount.billingDates[product]
        {
          code: product
          nextBillingDate: paidAccount.billingDates[product]
          interval: OrgFeatures.getInterval(product)
        }
      else
        productInfo
    , null)

    return productInfo

  getMultiBoardGuestBanner: ->
    dismissNotificationId = "#{MULTI_BOARD_GUEST}-#{@model.id}"
    if Auth.me().isDismissed(dismissNotificationId)
      return null

    product = @getNextProduct()
    if !product?
      return null

    trackUe(
      'multiboard guests banner',
      'displays',
      'multiboard guests banner',
      '',
      '',
      'by rendering the team settings page',
      { organizationid: @model.id, billableGuestCount: @model.get 'billableCollaboratorCount' }
    )

    onDismissBanner = =>
      trackUe(
        'multiboard guests banner',
        'dismisses',
        'multiboard guests banner',
        '',
        '',
        'by clicking the close button in corner',
        { organizationid: @model.id }
      )
      Auth.me().dismiss(dismissNotificationId)

    onClickButton = (buttonType, url, trackingDescription, openInNewWindow) =>
      trackUe(
        'multiboard guests banner',
        'visits',
        trackingDescription,
        '',
        '',
        "by clicking the #{buttonType} button",
        { organizationid: @model.id }
      )
      if openInNewWindow
        window.open(url, '_blank')
      else
        window.location = url

    multiBoardGuests = @model.get 'billableCollaboratorCount'
    effectiveDate = moment(new Date(product.nextBillingDate))
    # todo: figure out what the actual date should be
    gracePeriodEndDate = moment(new Date('2018-12-01T00:00:00.000z'))
    if multiBoardGuests > 0
      while effectiveDate < gracePeriodEndDate
        effectiveDate.add(
          1,
          if product.interval == 'monthly' then 'month' else 'year'
        )
    else
      effectiveDate = gracePeriodEndDate

    return recup.render =>
      recup.div =>
        recup.createElement MultiBoardGuestBannerComponent, {
          effectiveDate: effectiveDate.format('LL')
          multiBoardGuests
          price: OrgFeatures.getPrice(product.code)
          interval: product.interval,
          teamUrl: "/#{@model.get('name')}",
          onDismissBanner
          onClickButton
        }

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/organization/multi-board-guest-banner-view.coffee